import { DocumentBase } from "./document.model";
import { InitiatorType } from "../models/initiator.model";

export interface SignedLoanDocumentFile extends DocumentBase {
    signatures: DocumentSignatureData[];
}

export interface DocumentSignatureData extends IPGeolocation {
    signedAtUtc: string;
    signer: InitiatorDataDto;
    documentHash: string;
    signature: string;
    signatureVerificationStatus: SignatureVerificationStatus
}

export interface IPGeolocation {
    unknownIP: string;
    status: GeolocationStatus;
    error: string;
    resolvedAt: string;
    method: GeolocationResolutionMethod;
    ip: string;
    resolvedIP: string;
    hostName: string;
    asn: string;
    organization: string;
    position: GeographicalPosition;
    timeZone: GeographicalTimeZone;
}

export interface GeographicalPosition {
    latitude: number;
    longitude: number;
    city: string;
    region: string;
    postalCode: string;
    country: string;
}

export interface GeographicalTimeZone {
    name: string;
    utcOffset: string;
}

export interface InitiatorDataDto {
    id: string;
    type: InitiatorType;
    unique_id: string;
    email: string;
    firstname: string;
    lastName: string;
    fullName: string;
}

export enum GeolocationStatus
{
    Unresolved = 'unresolved',

    Resolved = 'resolved',

    Error = 'error'
}

export enum GeolocationResolutionMethod
{
    Direct = 'direct',
    Cache = 'cache'
}

export enum SignatureVerificationStatus {
    Unknown = 'unknown',
    Verified = 'verified',
    Invalid = 'invalid',
    NotSigned = 'not-signed',
    MissingCertificate = 'missing-certificate',
    VerificationException = 'verification-exception'
}